import * as React from 'react';
import * as styles from "./Confetti.css";
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../stores';
import { ConfettiElement } from './confettiElement/ConfettiElement';
import Snowfall from 'react-snowfall';
import { ITopItem } from '../../../interfaces/ITopItem';
import Confetti from 'confetti-react';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAButton } from '../../button/Button';
import { IAPopup } from '../../popup/Popup';
import { Helper } from '../../../Helper';

declare global {
  interface Window { snowStorm: any }
}

export interface IProps {
  navigatorStore?: NavigatorStore;
}

export interface IState {
  confettiWrapper: JSX.Element[];
  eggCount: number;
  eggIndex: number;
  userInteraction?: boolean;
}

@inject('navigatorStore')
@observer
export class IAConfetti extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      confettiWrapper: [],
      eggCount: 0,
      eggIndex: 0,
      userInteraction: false
    }
  }

  public componentDidMount(): void {
    // Halloween Confetti
    if (this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "halloweenconfetti") {
          this.setState({ userInteraction: element.config.userInteraction });
          if (localStorage.getItem("halloweenconfetti") == undefined && element.config.confettiEnabled) {
            Helper.setLocalStorage("halloweenconfetti", "halloweenconfetti");
          }
        }
      })
    }
    if (localStorage.getItem("halloweenconfetti") != undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      let navigatorHasHalloweenConfetti = false;
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "halloweenconfetti") {
          navigatorHasHalloweenConfetti = true;
        }
      });
      if (!navigatorHasHalloweenConfetti) {
        localStorage.removeItem("halloweenconfetti");
      } else {
        this.startConfetti();
      }
    }
    // Easter Confetti
    if (this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "easterconfetti") {
          this.setState({ userInteraction: element.config.userInteraction });
          if (localStorage.getItem("easterconfetti") == undefined && element.config.confettiEnabled) {
            Helper.setLocalStorage("easterconfetti", "easterconfetti");
          }
        }
      })
    }
    if (localStorage.getItem("easterconfetti") != undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      let navigatorHasEasterConfetti = false;
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "easterconfetti") {
          navigatorHasEasterConfetti = true;
        }
      });
      if (!navigatorHasEasterConfetti) {
        localStorage.removeItem("easterconfetti");
      } else {
        this.startConfetti();
      }
    }
    // Snow
    if (localStorage.getItem("letItSnow") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "snow" && element.config.snowEnabled) {
          Helper.setLocalStorage("letItSnow", "letItSnow");
        }
      })
    }
    if (localStorage.getItem("letItSnow") != undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      let navigatorHasSnow = false;
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "snow") {
          navigatorHasSnow = true;
        }
      });
      if (!navigatorHasSnow) {
        localStorage.removeItem("letItSnow");
      }
    }
    // Confetti
    if (localStorage.getItem("confetti") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "confetti" && element.config.confettiEnabled) {
          Helper.setLocalStorage("confetti", "confetti");
        }
      })
    }
    if (localStorage.getItem("confetti") != undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0) {
      let navigatorHasConfetti = false;
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "confetti") {
          navigatorHasConfetti = true;
        }
      });
      if (!navigatorHasConfetti) {
        localStorage.removeItem("confetti");
      }
    }
  }

  private startConfetti(): void {
    if (localStorage.getItem("easterconfetti") && localStorage.getItem("easterconfetti") === "easterconfetti") {
      this.addConfettiElement();
      setTimeout(() => {
        this.startConfetti();
      }, Math.floor(Math.random() * 1000));
    }
    if (localStorage.getItem("halloweenconfetti") && localStorage.getItem("halloweenconfetti") === "halloweenconfetti") {
      this.addConfettiElement();
      setTimeout(() => {
        this.startConfetti();
      }, Math.floor(Math.random() * 1000));
    }
  }

  private addConfettiElement(): void {
    const confettiWrapper = this.state.confettiWrapper ? this.state.confettiWrapper : [];
    const duration = Math.floor(Math.random() * (8 - 5) + 5);
    confettiWrapper.push(
      <ConfettiElement
        id={`ConfettiElement_${this.state.eggIndex}`}
        height={Math.random() * (100 - 60) + 50}
        image={localStorage.getItem("halloweenconfetti") ? `https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/halloween-confetti/halloween-${Math.floor(Math.random() * 9 + 1)}.png` : `https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/easter-confetti/egg_${Math.floor(Math.random() * 13 + 1)}.png`}
        duration={duration}
        rotation={Math.random() * (1000 - -1000) + -1000}
        left={Math.floor(Math.random() * ((screen.width - 400) + 200))}
        onClick={this.state.userInteraction ? () => {
          this.setState({ eggCount: this.state.eggCount + 1 }, () => this.forceUpdate());
        } : undefined}
      />
    );
    const id = this.state.eggIndex;
    setTimeout(() => {
      this.removeConfettiElement(`ConfettiElement_${id}`);
    }, (duration + 3) * 1000);
    this.setState({ confettiWrapper, eggIndex: this.state.eggIndex + 1 });
  }

  private removeConfettiElement(id: string): void {
    const confettiElement = document.getElementById(id);
    if (confettiElement) {
      confettiElement.outerHTML = "";
    }
  }

  render() {
    let showHalloweenConfetti = false;
    if (localStorage.getItem("halloweenconfetti") && localStorage.getItem("halloweenconfetti") === "halloweenconfetti" && document.getElementById("navigatorClassic") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0 && !this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.isMobile) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "halloweenconfetti") {
          showHalloweenConfetti = true;
        }
      })
    }
    let showEasterConfetti = false;
    if (localStorage.getItem("easterconfetti") && localStorage.getItem("easterconfetti") === "easterconfetti" && document.getElementById("navigatorClassic") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0 && !this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.isMobile) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "easterconfetti") {
          showEasterConfetti = true;
        }
      })
    }
    let showSnow = false;
    if (localStorage.getItem("letItSnow") && localStorage.getItem("letItSnow") === "letItSnow" && document.getElementById("navigatorClassic") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0 && !this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.isMobile) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "snow") {
          showSnow = true;
        }
      })
    }
    let showConfetti = false;
    if (localStorage.getItem("confetti") && localStorage.getItem("confetti") === "confetti" && document.getElementById("navigatorClassic") == undefined && this.props.navigatorStore.navigator && this.props.navigatorStore.navigator.smartmenu.elements.length > 0 && !this.props.navigatorStore.isInEditMode && !this.props.navigatorStore.isMobile) {
      this.props.navigatorStore.navigator.smartmenu.elements.forEach((element: ITopItem) => {
        if (element.config.subType === "confetti") {
          showConfetti = true;
        }
      })
    }
    return (
      <div>
        <div
          id="Snow"
          style={{
            display: localStorage.getItem("letItSnow") && localStorage.getItem("letItSnow") === "letItSnow" ? "block" : "none",
            position: 'fixed',
            top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 4000000,
            pointerEvents: "none",
            background: undefined
          }}>
          {showSnow &&
            <Snowfall
              color="white"
            />
          }
        </div>

        <div
          id="Confetti"
          style={{
            display: localStorage.getItem("confetti") && localStorage.getItem("confetti") === "confetti" ? "block" : "none",
            position: 'fixed',
            top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 4000000,
            pointerEvents: "none",
            background: undefined
          }}>
          {showConfetti &&
            <Confetti
              width={screen.width}
              height={screen.height}
              gravity={0.05}
              numberOfPieces={200}
            // colors={["red", "white"]}
            />
          }
        </div>
        <div
          id="ConfettiWrapper"
          style={{
            display: "block",
            position: 'fixed',
            top: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 4000000,
            pointerEvents: "none",
            background: undefined
          }}>
          {/* {(showEasterConfetti || showHalloweenConfetti) && */}
          {
            this.state.confettiWrapper
          }
        </div>
        {(showEasterConfetti || showHalloweenConfetti) && this.state.userInteraction &&
          <div className={styles.IA_basket}>
            {this.state.eggCount === 0 ? "" : this.state.eggCount}
          </div>
        }
        {this.props.navigatorStore.showSnowPopup &&
          <IAPopup
            headline={new LocalizationService().strings.Navigator_SnowPopupHeadline}
            headlineColor={"#ffffff"}
            headlineSize={24}
            headlineWidth={"60%"}
            fontSlots={this.props.navigatorStore.fontSlots}
            backgroundImage={"https://intraactivestorage.blob.core.windows.net/cdn/images/snow-popup.png"}
            closeButtonColor={"#90aaab"}
            closeButtonBackground={"#ffffff"}
            content={
              <div>
                {localStorage.getItem("letItSnow") && localStorage.getItem("letItSnow") === "letItSnow" &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_SnowPopupStopSnowing}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("letItSnow", "noSnow");
                      this.props.navigatorStore.showSnowPopup = false;
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
                {(localStorage.getItem("letItSnow") == undefined || localStorage.getItem("letItSnow") && localStorage.getItem("letItSnow") !== "letItSnow") &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_SnowPopupStartSnowing}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("letItSnow", "letItSnow");
                      this.props.navigatorStore.showSnowPopup = false;
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
              </div>
            }
            close={() => this.props.navigatorStore.showSnowPopup = !this.props.navigatorStore.showSnowPopup}
          />
        }
        {this.props.navigatorStore.showConfettiPopup &&
          <IAPopup
            headline={new LocalizationService().strings.Navigator_ConfettiPopupHeadline}
            headlineColor={"#333333"}
            headlineSize={24}
            headlineWidth={"60%"}
            fontSlots={this.props.navigatorStore.fontSlots}
            backgroundImage={"https://intraactivestorage.blob.core.windows.net/cdn/images/confetti-popup.png"}
            closeButtonColor={"#90aaab"}
            closeButtonBackground={"#ffffff"}
            content={
              <div>
                {localStorage.getItem("confetti") && localStorage.getItem("confetti") === "confetti" &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStopConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("confetti", "noSnow");
                      this.props.navigatorStore.showConfettiPopup = false;
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
                {(localStorage.getItem("confetti") == undefined || localStorage.getItem("confetti") && localStorage.getItem("confetti") !== "confetti") &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStartConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("confetti", "confetti");
                      this.props.navigatorStore.showConfettiPopup = false;
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
              </div>
            }
            close={() => this.props.navigatorStore.showConfettiPopup = !this.props.navigatorStore.showConfettiPopup}
          />
        }
        {this.props.navigatorStore.showEasterConfettiPopup &&
          <IAPopup
            headline={new LocalizationService().strings.Navigator_EasterPopupHeadline}
            headlineColor={"#333333"}
            headlineSize={24}
            headlineWidth={"60%"}
            backgroundImage={"https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/easter-confetti/easter-popup.png"}
            fontSlots={this.props.navigatorStore.fontSlots}
            closeButtonColor={"#90aaab"}
            closeButtonBackground={"#ffffff"}
            content={
              <div>
                {localStorage.getItem("easterconfetti") && localStorage.getItem("easterconfetti") === "easterconfetti" &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStopConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("easterconfetti", "noEasterConfetti");
                      this.props.navigatorStore.showEasterConfettiPopup = false;
                      this.setState({ eggCount: 0, eggIndex: 0 });
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
                {(localStorage.getItem("easterconfetti") == undefined || localStorage.getItem("easterconfetti") && localStorage.getItem("easterconfetti") !== "easterconfetti") &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStartConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("easterconfetti", "easterconfetti");
                      this.props.navigatorStore.showEasterConfettiPopup = false;
                      this.startConfetti();
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
              </div>
            }
            close={() => this.props.navigatorStore.showEasterConfettiPopup = !this.props.navigatorStore.showEasterConfettiPopup}
          />
        }
        {this.props.navigatorStore.showHalloweenConfettiPopup &&
          <IAPopup
            headline={new LocalizationService().strings.Navigator_HalloweenPopupHeadline}
            headlineColor={"#ffffff"}
            headlineSize={24}
            headlineWidth={"60%"}
            fontSlots={this.props.navigatorStore.fontSlots}
            backgroundImage={"https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/halloween-confetti/halloween-popup.png"}
            closeButtonColor={"#90aaab"}
            closeButtonBackground={"#ffffff"}
            content={
              <div>
                {localStorage.getItem("halloweenconfetti") && localStorage.getItem("halloweenconfetti") === "halloweenconfetti" &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStopConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("halloweenconfetti", "nohalloweenConfetti");
                      this.props.navigatorStore.showHalloweenConfettiPopup = false;
                      this.setState({ eggCount: 0, eggIndex: 0 });
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
                {(localStorage.getItem("halloweenconfetti") == undefined || localStorage.getItem("halloweenconfetti") && localStorage.getItem("halloweenconfetti") !== "halloweenconfetti") &&
                  <IAButton
                    label={new LocalizationService().strings.Navigator_ConfettiPopupStartConfetti}
                    buttonColor={"#ffffff"}
                    textColor="#1c534c"
                    showSpinner={false}
                    fontSize={15}
                    onClick={() => {
                      Helper.setLocalStorage("halloweenconfetti", "halloweenconfetti");
                      this.props.navigatorStore.showHalloweenConfettiPopup = false;
                      this.startConfetti();
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left",
                      marginBottom: 8
                    }}
                  />
                }
              </div>
            }
            close={() => this.props.navigatorStore.showHalloweenConfettiPopup = !this.props.navigatorStore.showHalloweenConfettiPopup}
          />
        }
      </div>
    )
  }


}